/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react';

import BottomMenuCommon from '../../menu/bottommenu/BottomMenuCommon';

const AdvSetupMenu = {
  GENERAL: 'GENERAL SETUP',
  CONCENTRATE: 'CONCENTRATE',
  DIAFILTRATION: 'BUFFER EXCHANGE',
  PRIME: 'PRIME',
  RECOVERY: 'RECOVERY',
  CYCLE_SETUP: 'CYCLE SETUP',
};

function AdvSetupPageMenu({activePage, onChangeMenu}) {
  const onClick = (e) => {
    switch (e.currentTarget.id) {
      case AdvSetupMenu.GENERAL:
        onChangeMenu(AdvSetupMenu.GENERAL);
        break;
      case AdvSetupMenu.CYCLE_SETUP:
        onChangeMenu(AdvSetupMenu.CYCLE_SETUP);
        break;
      default:
        onChangeMenu(AdvSetupMenu.GENERAL);
        break;
    }
  };
  const [buttonMenuParam, setButtonMenuParam] = useState({
    activeId: activePage,
    buttonProps: [
      {id: AdvSetupMenu.GENERAL, label: AdvSetupMenu.GENERAL, onClick},
      {id: AdvSetupMenu.CYCLE_SETUP, label: AdvSetupMenu.CYCLE_SETUP, onClick},
    ],
  });

  useEffect(() => {
    const btnMenuParam = {
      activeId: activePage,
      buttonProps: [
        {id: AdvSetupMenu.GENERAL, label: AdvSetupMenu.GENERAL, onClick},
        {id: AdvSetupMenu.CYCLE_SETUP, label: AdvSetupMenu.CYCLE_SETUP, onClick},
      ],
    };

    setButtonMenuParam(btnMenuParam);
  }, [activePage]);

  return <BottomMenuCommon buttonParam={buttonMenuParam} />;
}

export default AdvSetupPageMenu;
